import moment from "moment";

export default function GetDatetime(justDate) {
  if (justDate) {
    return moment().format("YYYY-MM-DD");
  } else {
    return moment().format("YYYY-MM-DD HH:mm:ss.SSS");
  }
}
